function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#CCCCCC;}\r\n\t.st1{fill:none;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "photo"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 300.18,
  cy: 200.09,
  r: 26.7
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M275.18,116.79l-15.3,16.7h-26.4c-9.2,0-16.7,7.5-16.7,16.7v100c0,9.2,7.5,16.7,16.7,16.7h133.3 c9.2,0,16.7-7.5,16.7-16.7v-100.1c0-9.2-7.5-16.7-16.7-16.7h-26.4l-15.2-16.6H275.18z M300.18,241.79c-23,0-41.7-18.7-41.7-41.7 s18.7-41.7,41.7-41.7s41.7,18.7,41.7,41.7S323.18,241.79,300.18,241.79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M200.18,100.09h200v200h-200V100.09z"
}));

var SvgPlaceholderList = function SvgPlaceholderList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 400",
    style: {
      enableBackground: "new 0 0 600 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaceholderList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placeholder_list.af0585ea.svg";
export { ForwardRef as ReactComponent };